import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
/*global google*/
import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import { compose, withProps, withStateHandlers } from 'recompose';
const REACT_APP_GOOGLE_MAPS_API_TOKEN = process.env.REACT_APP_GOOGLE_MAPS_API_TOKEN;
const MyMap = compose(withProps({
  googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=".concat(REACT_APP_GOOGLE_MAPS_API_TOKEN),
  loadingElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }),
  containerElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }),
  mapElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  })
}), withStateHandlers(() => ({
  isMarkerShown: false,
  markerPosition: null
}), {
  onMapClick: () => e => ({
    markerPosition: e.latLng,
    isMarkerShown: true
  })
}), withScriptjs, withGoogleMap)(_ref => {
  let {
    mapRef,
    defaultCenter,
    markerPosition,
    isMarkerShown,
    onMapClick,
    onIdle,
    autocompletePosition = null,
    mapCenter,
    onMClick,
    showMarker
  } = _ref;
  const [markPosition, setMarkPosition] = useState(null);
  const [geocoder, setGeocoder] = useState(null);
  const [markerVisible, setMarkerVisible] = useState(isMarkerShown);
  useEffect(() => {
    setMarkerVisible(isMarkerShown);
  }, [isMarkerShown]);
  useEffect(() => {
    setMarkerVisible(showMarker);
  }, [showMarker]);
  useEffect(() => {
    setGeocoder(new google.maps.Geocoder());
  }, []);
  useEffect(() => {
    if (markerPosition) {
      setMarkPosition(markerPosition);
      const [lat, lng] = [markerPosition.lat(), markerPosition.lng()];
      const latLng = new google.maps.LatLng(lat, lng);
      if (geocoder) {
        geocoder.geocode({
          latLng: latLng
        }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              onMClick({
                position: markerPosition,
                address: results[0]
              });
            } else {
              alert('No results found');
            }
          } else {
            alert('Geocoder failed due to: ' + status);
          }
        });
      }
    }
    //eslint-disable-next-line
  }, [geocoder, markerPosition]);
  useEffect(() => {
    if (autocompletePosition) {
      setMarkPosition(autocompletePosition);
      setMarkerVisible(true);
    }
  }, [autocompletePosition]);
  return /*#__PURE__*/React.createElement(GoogleMap, {
    ref: mapRef,
    defaultZoom: 16,
    defaultCenter: defaultCenter,
    onClick: onMapClick,
    onIdle: () => onIdle(google),
    center: mapCenter || defaultCenter
  }, markerVisible && /*#__PURE__*/React.createElement(Marker, {
    position: markPosition || defaultCenter
  }));
});
const MapWrapper = _ref2 => {
  let {
    style,
    className,
    defaultCenter = {
      lat: 0,
      lng: 0
    },
    autocompleteRef = null,
    onMapClick = () => {},
    isMarkerShown = false,
    onPlaceSelected = () => {}
  } = _ref2;
  const [googleObject, setGoogleObject] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const map = useRef();
  useEffect(() => {
    if (googleObject) {
      if (autocompleteRef) {
        setAutocomplete(new googleObject.maps.places.Autocomplete(autocompleteRef.current, {
          types: ['geocode']
        }));
      }
    }
  }, [autocompleteRef, googleObject]);
  useEffect(() => {
    if (autocomplete) {
      const handlePlaceChanged = () => {
        const place = autocomplete.getPlace();
        const LatLng = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        setMarkerPosition(LatLng);
        setMapCenter(LatLng);
        onPlaceSelected(place);
        // console.log('stile', place);
      };
      if (googleObject) {
        googleObject.maps.event.addListener(autocomplete, 'place_changed', handlePlaceChanged);
      }
    }
    //eslint-disable-next-line
  }, [autocomplete, googleObject]);
  const handleOnIdle = google => {
    if (!googleObject) {
      setGoogleObject(google);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, style),
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement(MyMap, {
    defaultCenter: defaultCenter,
    autocomplete: autocompleteRef,
    onIdle: handleOnIdle,
    autocompletePosition: markerPosition,
    mapRef: map,
    mapCenter: mapCenter,
    onMClick: onMapClick,
    showMarker: isMarkerShown
  }));
};
export { MapWrapper as GoogleMap };